import { cn } from '../../../../lib/utils';

interface LoadingSpinnerProps {
  size?: 'xsmall' | 'small' | 'medium' | 'large';
  direction?: 'clockwise' | 'counterclockwise';
  className?: string;
}

export default function LoadingSpinner({
  /** 로딩 스피너 크기 */
  size = 'medium',
  /** 로딩 스피너 회전 방향 */
  direction = 'clockwise',
  /** 로딩 스피너 클래스네임 */
  className,
}: LoadingSpinnerProps) {
  const sizeMap = {
    xsmall: 'w-[12px] h-[12px]',
    small: 'w-[16px] h-[16px]',
    medium: 'w-[20px] h-[20px]',
    large: 'w-[24px] h-[24px]',
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cn(
        direction === 'clockwise' ? 'animate-spin' : 'animate-spin-reverse',
        sizeMap[size],
      )}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.42857C7.26613 3.42857 3.42857 7.26613 3.42857 12C3.42857 16.7339 7.26613 20.5714 12 20.5714C16.7339 20.5714 20.5714 16.7339 20.5714 12C20.5714 11.0532 21.3389 10.2857 22.2857 10.2857C23.2325 10.2857 24 11.0532 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C12.9468 0 13.7143 0.767512 13.7143 1.71429C13.7143 2.66106 12.9468 3.42857 12 3.42857Z"
        className={cn(
          // 기본 색상: className이 전달되면 tailwind-merge가 자동으로 오버라이드 처리
          'fill-comp-loading-spinner-fill',
          className, // className으로 색상 커스터마이징 가능 (예: fill-sys-cont-neutral-light)
        )}
      />
    </svg>
  );
}
